export const Runner = (props: any) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.7681 6.25159L8.39199 15.6789L6.24154 16.7667L3.55347 14.2286" stroke="#011BB6" strokeWidth="2"/>
      <path d="M10.4634 13.4618L13.0922 15.119L14.9698 19.17" stroke="#011BB6" strokeWidth="2"/>
      <path d="M12.2661 8.65503H7.62815L6.55786 9.85675" stroke="#011BB6" strokeWidth="2"/>
      <path d="M12.5667 8.65503L15.5991 11.9598L18.2748 11.438" stroke="#011BB6" strokeWidth="2"/>
      <ellipse cx="14.6697" cy="4.44897" rx="2.10302" ry="2.10302" stroke="#011BB6" strokeWidth="2"/>
    </svg>
  )
}